import axios from 'axios';
import { ENV_CONFIG } from '../constant';
import ENVIRONMENT from '../constant/environment';
import { TOPCONECT, METHOD, RESPONSE_TYPE, KEY } from '../constant/api';

export class ApiBase {
  private static http = axios.create({
    baseURL: this.EndpointGenerator(),
    headers: {
      'x-api-key': this.KeyGenerator(),
    },
    responseType: RESPONSE_TYPE,
  });

  static token: string = '';

  private static EndpointGenerator(): string {
    switch (ENV_CONFIG) {
      case ENVIRONMENT.DEV:
        return TOPCONECT.ENDPOINT.DEV;
      case ENVIRONMENT.QA:
        return TOPCONECT.ENDPOINT.QA;
      case ENVIRONMENT.PROD:
        return TOPCONECT.ENDPOINT.PROD;
      default:
        return TOPCONECT.ENDPOINT.DEV;
    }
  }

  private static KeyGenerator(): string {
    switch (ENV_CONFIG) {
      case ENVIRONMENT.DEV:
        return KEY.DEV;
      case ENVIRONMENT.QA:
        return KEY.QA;
      case ENVIRONMENT.PROD:
        return KEY.PROD;
      default:
        return KEY.DEV;
    }
  }

  static setToken(token: string) {
    this.token = token;
  }

  static async sendRequest(
    method: keyof typeof METHOD,
    url: string,
    data: any,
    config: any
  ): Promise<any> {
    data = JSON.stringify(data);

    try {
      let response;
      switch (method) {
        case METHOD.GET:
          response = await this.http.get(url, config);
          break;
        case METHOD.POST:
          response = await this.http.post(url, data, config);
          break;
        case METHOD.PUT:
          response = await this.http.put(url, data, config);
          break;
        case METHOD.DELETE:
          response = await this.http.delete(url, config);
          break;
        default:
          console.log('Invalid HTTP Method');
          return;
      }

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}
